import each from 'lodash/each';
import { css } from 'styled-components';

import { mq } from '../styles/grid';

/**
 * @param {Theme} theme
 * @returns {FlattenInterpolation<{ theme: Theme }>}
 */
const getHtmlTagSpacing = (theme) => {
  const blocks = [];

  each(theme.spacingMap.globals, (val, key) => {
    Object.entries(val).forEach(([after, spacing]) => {
      blocks.push(css`
        ${key} + ${after} {
          margin-top: ${theme.spacing.xl[spacing]};

          @media (${mq.smDown}) {
            margin-top: ${theme.spacing.xs[spacing]};
          }
        }
      `);
    });
  });

  return css`
    ${blocks}
  `;
};

export default getHtmlTagSpacing;
